/**
 * Newsletter Types
 * 
 * TypeScript definitions for newsletter and subscriber data.
 * Used for future newsletter functionality.
 */

export interface Subscriber {
  id: string;
  email: string;
  name?: string;
  status: SubscriberStatus;
  subscribedAt: string;
  unsubscribedAt?: string;
  source: SubscriberSource;
  preferences?: SubscriberPreferences;
}

export enum SubscriberStatus {
  ACTIVE = 'active',
  UNSUBSCRIBED = 'unsubscribed',
  PENDING = 'pending',
  BOUNCED = 'bounced',
}

export enum SubscriberSource {
  WEBSITE = 'website',
  MANUAL = 'manual',
  IMPORT = 'import',
}

export interface SubscriberPreferences {
  categories?: string[];
  frequency?: 'daily' | 'weekly' | 'monthly';
}

export interface SubscriberCreateInput {
  email: string;
  name?: string;
  source?: SubscriberSource;
  preferences?: SubscriberPreferences;
}

export interface Newsletter {
  id: string;
  title: string;
  subject: string;
  content: string;
  status: NewsletterStatus;
  scheduledAt?: string;
  sentAt?: string;
  recipientCount: number;
  openCount?: number;
  clickCount?: string;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
}

export enum NewsletterStatus {
  DRAFT = 'draft',
  SCHEDULED = 'scheduled',
  SENT = 'sent',
  FAILED = 'failed',
}

export interface NewsletterCreateInput {
  title: string;
  subject: string;
  content: string;
  scheduledAt?: string;
}

export interface NewsletterHistory {
  id: string;
  newsletterId: string;
  sentAt: string;
  recipientCount: number;
  status: 'delivered' | 'failed' | 'bounced';
  details?: string;
}

export interface EmailTemplate {
  id: string;
  name: string;
  subject: string;
  content: string;
  variables: string[];
  createdAt: string;
  updatedAt: string;
}

export const SUBSCRIBERS_COLLECTION = 'newsletter_subscribers';
export const NEWSLETTERS_COLLECTION = 'newsletters';
export const NEWSLETTER_HISTORY_COLLECTION = 'newsletter_history';
export const EMAIL_TEMPLATES_COLLECTION = 'email_templates';